







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SvgText extends Vue {
  @Prop({ required: true, type: Number })
  public width!: number;

  @Prop({ required: true, type: Number })
  public height!: number;

  @Prop({ required: false, default: '#fff', type: String })
  public color!: string;

  @Prop({ required: false, default: '16px', type: String })
  public fontSize!: string;

  get viewBox() {
    return `0 0 ${this.width} ${this.height}`;
  }
}
